var womensTops = {
  category: "Women's",
  product: "Tops + Cardigans",
  sections: [{
      section: {
        title: "Size Chart",
        type: "table",
        header: [
          "Shirt Size","",
          "Your Bust",
          "Your Natural Waist",
          "Your Hips",
          "Your Arm (Spine To Wrist)"
        ],
        rows: [
          ["XS", "","32.5 - 33.5", "25 - 26", "35 - 36", "30 - 30.25"],
          ["S", "","34.5 - 35.5", "27 - 28", "37 - 38", "30.5 - 30.75"],
          ["M", "","36.5 - 37.5", "29 - 30", "39 - 40", "31 - 31.25"],
          ["L", "","39 - 40.5", "31.5 - 33", "41.5 - 43", "31.5 - 31.75"],
          ["XL", "","42 - 43.5", "34.5 - 36", "44.5 - 46", "32 - 32.25"]
        ]
      }
    },
    {
      section: {
        title: "Fit Guidance",
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_Tops_-_Standard.png?14314",
            title: "Standard:",
            body: "A modern feminine fit, relaxed through the body with shaping at the waist."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_Tops_-_Petite.png?14314",
            title: "Petite:",
            body: "1.5” (3.8 cm) proportionally shorter in body and sleeve than our Standard Fit to accommodate heights of 5’3” (160 cm) or under."
          }]
        ]
      }
    },
    {
      section: {
        title: 'How to Measure',
        type: "singleCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_-_How_To_Measure.png?14316"
          }],
          [{
            title: "Bust: ",
            body: "Wrap the measuring tape around your chest, under your arm, at the fullest part of the bust, keeping the tape slightly loose."
          }],
          [{
            title: "Arm (Spine to Wrist): ",
            body: "The arm measurement used for sleeve length is measured from the center back of your neck to your wrist. Hold your arm out to the side with your elbow slightly bent, and measure from the back center of your neck (spine) down the outside of your arm to your wrist bone."
          }],
          [{
            title: "Natural Waist: ",
            body: "Bend to the side to find the natural crease of your waist. Stand normally and wrap the measuring tape at this point, keeping the tape slightly loose."
          }],
          [{
            title: "Hips: ",
            body: "With your feet together, wrap the measuring tape around the fullest part of your hips/seat, approximately 8\" (20.3 cm) below your natural waist, keeping the tape slightly loose."
          }],
          [{
            title: "Thigh: ",
            body: "Wrap the measuring tape around the fullest part of your thigh, approximately 1\" (2.5 cm) below the crotch, keeping the tape slightly loose."
          }]
        ]
      }
    }
  ]
};